(() => {
  const REFRESH_MS = 300000;
  const TIMEOUT_MS = 8000;

  document.querySelectorAll("[data-hero-campaign]").forEach((root) => {
    if (root.dataset.campaignBound) return;
    root.dataset.campaignBound = "true";

    const campaignContent = root.querySelector("[data-hero-campaign-content]");
    const defaultContent = root.querySelector("[data-hero-default-content]");
    const firstSlide = root.querySelector("[data-hero-slide='0']");
    const image = firstSlide?.querySelector("[data-hero-media] img");
    const controls = root.querySelector(".hero__controls");
    if (!campaignContent || !defaultContent || !firstSlide || !image) return;

    const fields = {
      title: campaignContent.querySelector("[data-campaign-title]"),
      text: campaignContent.querySelector("[data-campaign-text]"),
      value: campaignContent.querySelector("[data-campaign-value]"),
      code: campaignContent.querySelector("[data-campaign-code]"),
      start: campaignContent.querySelector("[data-campaign-start]"),
      end: campaignContent.querySelector("[data-campaign-end]"),
      scheduled: campaignContent.querySelector("[data-campaign-scheduled]"),
      link: campaignContent.querySelector("[data-campaign-link]"),
      copy: campaignContent.querySelector("[data-campaign-copy]"),
    };
    const originalImage = {
      src: image.getAttribute("src"),
      srcset: image.getAttribute("srcset"),
      sizes: image.getAttribute("sizes"),
      alt: image.getAttribute("alt"),
    };
    let clockOffset = 0;
    let refreshTimer;
    let boundaryTimer;
    let requestNumber = 0;
    let latestServerTime = 0;

    const restoreImage = () => {
      image.setAttribute("src", originalImage.src);
      if (originalImage.srcset === null) image.removeAttribute("srcset"); else image.setAttribute("srcset", originalImage.srcset);
      if (originalImage.sizes === null) image.removeAttribute("sizes"); else image.setAttribute("sizes", originalImage.sizes);
      if (originalImage.alt === null) image.removeAttribute("alt"); else image.setAttribute("alt", originalImage.alt);
    };
    const clearTimers = () => {
      window.clearTimeout(refreshTimer);
      window.clearTimeout(boundaryTimer);
    };
    const reset = () => {
      clearTimers();
      root.removeAttribute("data-campaign-state");
      campaignContent.hidden = true;
      defaultContent.hidden = false;
      if (controls) controls.hidden = false;
      restoreImage();
      root.dispatchEvent(new CustomEvent("hero:campaign", { detail: { active: false } }));
    };
    const validImageUrl = (value) => {
      try { return new URL(value).protocol === "https:"; } catch (_) { return false; }
    };
    const validCampaign = (value) => {
      if (!value || typeof value !== "object") return false;
      const startsAt = Date.parse(value.startsAt);
      const endsAt = Date.parse(value.endsAt);
      return typeof value.title === "string" && value.title.trim()
        && typeof value.text === "string" && value.text.trim()
        && typeof value.discountCode === "string" && value.discountCode.trim()
        && ["percentage", "fixed"].includes(value.discountType)
        && Number.isFinite(value.discountValue) && value.discountValue > 0
        && typeof value.currencyCode === "string" && /^[A-Z]{3}$/.test(value.currencyCode)
        && ["scheduled", "active"].includes(value.status)
        && Number.isFinite(startsAt) && Number.isFinite(endsAt) && startsAt < endsAt;
    };
    const formatDate = (value) => new Intl.DateTimeFormat(root.dataset.campaignLocale || "de", {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone: "Europe/Zurich",
    }).format(new Date(value));
    const formatDiscount = (campaign) => campaign.discountType === "percentage"
      ? new Intl.NumberFormat(root.dataset.campaignLocale || "de", { style: "percent", maximumFractionDigits: 2 }).format(campaign.discountValue / 100)
      : new Intl.NumberFormat(root.dataset.campaignLocale || "de", { style: "currency", currency: campaign.currencyCode }).format(campaign.discountValue);
    const schedule = (campaign) => {
      const now = Date.now() + clockOffset;
      const boundary = campaign.status === "scheduled" ? Date.parse(campaign.startsAt) : Date.parse(campaign.endsAt);
      const delay = Math.max(0, Math.min(REFRESH_MS, boundary - now + 50));
      refreshTimer = window.setTimeout(load, REFRESH_MS);
      boundaryTimer = window.setTimeout(() => {
        if (campaign.status === "active") reset();
        load();
      }, delay);
    };
    const render = (campaign) => {
      const now = Date.now() + clockOffset;
      const startsAt = Date.parse(campaign.startsAt);
      const endsAt = Date.parse(campaign.endsAt);
      const visible = campaign.status === "scheduled" ? now < startsAt : now >= startsAt && now < endsAt;
      if (!visible) {
        reset();
        refreshTimer = window.setTimeout(load, REFRESH_MS);
        return;
      }
      fields.title.textContent = campaign.title.trim();
      fields.text.textContent = campaign.text.trim();
      fields.value.textContent = formatDiscount(campaign);
      fields.code.textContent = campaign.discountCode.trim();
      fields.start.textContent = formatDate(campaign.startsAt);
      fields.start.setAttribute("datetime", campaign.startsAt);
      fields.end.textContent = formatDate(campaign.endsAt);
      fields.end.setAttribute("datetime", campaign.endsAt);
      fields.scheduled.hidden = campaign.status !== "scheduled";
      fields.link.hidden = campaign.status !== "active";
      fields.copy.textContent = fields.copy.dataset.copyLabel;
      if (validImageUrl(campaign.imageUrl)) {
        image.src = campaign.imageUrl;
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.alt = typeof campaign.imageAlt === "string" ? campaign.imageAlt : "";
      } else {
        restoreImage();
      }
      root.dataset.campaignState = campaign.status;
      defaultContent.hidden = true;
      campaignContent.hidden = false;
      if (controls) controls.hidden = true;
      root.dispatchEvent(new CustomEvent("hero:campaign", { detail: { active: true } }));
      schedule(campaign);
    };
    async function load() {
      const currentRequest = ++requestNumber;
      clearTimers();
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), TIMEOUT_MS);
      try {
        const locale = encodeURIComponent(root.dataset.campaignLocale || document.documentElement.lang || "de");
        const response = await fetch(`/apps/seifeops/hero-campaign?locale=${locale}`, {
          cache: "no-store",
          credentials: "same-origin",
          headers: { Accept: "application/json" },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error("campaign unavailable");
        const payload = await response.json();
        const serverTime = Date.parse(payload?.serverTime);
        if (currentRequest !== requestNumber || !Number.isFinite(serverTime) || (latestServerTime > 0 && serverTime <= latestServerTime)) throw new Error("stale campaign response");
        latestServerTime = serverTime;
        clockOffset = serverTime - Date.now();
        if (payload.campaign === null) {
          reset();
          refreshTimer = window.setTimeout(load, REFRESH_MS);
        } else if (validCampaign(payload.campaign)) render(payload.campaign);
        else throw new Error("invalid campaign");
      } catch (_) {
        if (currentRequest === requestNumber) {
          reset();
          refreshTimer = window.setTimeout(load, REFRESH_MS);
        }
      } finally {
        window.clearTimeout(timeout);
      }
    }

    fields.copy.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(fields.code.textContent);
        fields.copy.textContent = fields.copy.dataset.copiedLabel;
      } catch (_) {
        fields.code.focus?.();
      }
    });
    image.addEventListener("error", () => {
      if (image.getAttribute("src") !== originalImage.src) restoreImage();
    });
    reset();
    load();
  });
})();